<div *ngIf="isDpe()" class="m-2">
  <ng-container *ngIf="value && loadedLib; else noDpe">
    <h4>Consommations énergétiques</h4>
    <span class="font-weight-bold mt-2">Logement économe</span>
    <div id="dpe">
      <ng-template *ngIf="value; then showDpe()"></ng-template>
    </div>
    <span class="font-weight-bold mt-2">Logement énergivore</span>
    <p class="mt-2 font-italic">Unité de mesure exprimée en kWhEP/m².an</p>
  </ng-container>
  <ng-template #noDpe>
    <span class="no-content dark">Renseignez votre indice de consommation pour visualiser le DPE</span>
  </ng-template>
</div>
<div *ngIf="isGes()" class="m-2">
  <ng-container *ngIf="value && loadedLib; else noGes">
    <h4>Émission de gaz à effet de serre</h4>
    <span class="font-weight-bold mt-2">Faible émission</span>
    <div id="ges">
      <ng-template *ngIf="value; then showGes()"></ng-template>
    </div>
    <span class="font-weight-bold mt-2">Forte émission</span>
    <p class="mt-2 font-italic">Unité de mesure exprimée en kgeqCO2/m².an</p>
  </ng-container>
  <ng-template #noGes>
    <span class="no-content dark">Renseignez votre indice d'émission pour visualiser le GES</span>
  </ng-template>
</div>
